import React from 'react';
import Loading from "../molcules/Loading/Loading";
import Paper from '@mui/material/Paper';
import Button from "@mui/material/Button";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {deleteOne, get} from "./api";
import {get as getSites} from "../Sites/api";
import MyTable from "../atoms/MyTable";
import QuestionsForm from "./QuestionsForm";
import {useQuery, useQueryClient} from "@tanstack/react-query";
import DeleteDialog from "../molcules/Dialogs/DeleteDialog";

export default function QuestionsList({venueID}) {
  const queryClient = useQueryClient();
  const { isLoading = true, data, error } = useQuery({
    queryKey: ['questions', venueID],
    queryFn: () => get(venueID)
  });
  const { data: sitesData } = useQuery({
    queryKey: ['sites'],
    queryFn: getSites
  });

  const sitesMap = React.useMemo(() => {
    if (!sitesData?.data) return {};
    return Object.fromEntries(sitesData.data.map(s => [s._id, s.name]));
  }, [sitesData]);

  const questionsData = data?.data || [];

  const columns = React.useMemo(() => [
    { title: 'Property', align:'left', field: 'propertyName'},
    { title: 'Question', align:'right', field: 'label'},
    { title: 'Category', align:'right', field: 'category'},
    { title: 'Type', align:'right', field: 'type'},
    { title: 'Sites', align:'right', field: 'venueIds', format: (venueIds) => {
      if (!venueIds || venueIds.length === 0) return 'All';
      return venueIds.map(id => sitesMap[id] || id).join(', ');
    }}
  ], [sitesMap]);

  const actions = React.useMemo(() => ([
    {
      content: (<Button variant={'contained'} size={'small'} color={'error'}>Delete</Button>),
      id: 'delete'
    }
  ]), []);

  const [tableState, setTableState] = React.useState({
    data: [],
    questionEditOpen: false,
    create:false,
    selectedQuestion:{},
    showDelete: false
  });

  const handleCloseStaffEdit = () => {
    //fetchUsers();
    queryClient.invalidateQueries('questions');
    setTableState(prev => {
      return {...prev, questionEditOpen: false};
    });
  };

  if (error) return <p>An error has occurred: {error.message}</p>;

  return (
    <div>
      <QuestionsForm
        open={tableState.questionEditOpen}
        question={tableState.selectedQuestion}
        create={tableState.create}
        venueID={venueID}
        onClose={handleCloseStaffEdit}
      />
      <DeleteDialog
        heading={'Are you sure you want to delete this question?'}
        message={'This action cannot be undone. The question will be permanently removed.'}
        show={tableState.showDelete}
        onDelete={() => {
          if (tableState.selectedQuestion?._id) {
            deleteOne(tableState.selectedQuestion._id).then(() => {
              queryClient.invalidateQueries('questions');
              setTableState(prev => {
                return {...prev, showDelete: false, selectedQuestion: {}};
              });
            });
          }
        }}
        onClose={() => {
          setTableState(prev => {
            return {...prev, showDelete: false};
          });
        }}
      />
      <div className="heading"><span className="heading-text">{venueID ? 'Venue' : 'Global'} Questions</span>
          <Button
            onClick={() => {
              setTableState(prev => {
                return {...prev, create: true, questionEditOpen: true}
              });
            }}
            variant="outlined"
            color="primary"
            startIcon={<AddCircleOutlineIcon />}>New</Button>
      </div>
        {isLoading && <Loading/> }
        {!isLoading && !questionsData.length && <p>No question found.</p>}
        {!isLoading && questionsData.length > 0 &&
        <Paper className={'paper'}>
          <MyTable
            title={''}
            columns={columns}
            actions={actions}
            data={questionsData}
            initialOrder={{orderBy:'position', order:'asc'}}
            onRowClick={(event, question) => {
              setTableState(prev => {
                return {...prev, questionEditOpen: true, create:false, selectedQuestion: question}
              });
            }}
            onActionClick={(event, actionId, question) => {
              event.stopPropagation();
              if (actionId === 'delete') {
                setTableState(prev => {
                  return {...prev, selectedQuestion: question, showDelete: true};
                });
              }
            }}
          />
        </Paper>}
    </div>
  );
}
